import type { ITuvisMessagingProvider } from "@whatslly/ui-components/Pages/TuvisMessaging/TuvisMessagingProvider";
import { injectable, inject } from "inversify";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { InjectUserStore } from "@whatslly/ui-components/services/UserStore";
import type { IOrganizationStore } from "../../../services/IOrganizationStore";
import { InjectOrganizationStore } from "../../../services/IOrganizationStore";
@injectable()
export class PlatformTuvisMessagingProvider implements ITuvisMessagingProvider {
  constructor(
    @inject(InjectUserStore) private readonly userStore: IUserStore,
    @inject(InjectOrganizationStore) private readonly orgStore: IOrganizationStore
  ) {}

  get etoken() {
    return this.userStore.etoken ?? "";
  }

  get pod() {
    return this.userStore.pod ?? "";
  }

  async getOrgId() {
    const org = await this.orgStore.selectedOrg;
    return org?.value ?? this.userStore.user?.organizationId;
  }
}
